import React from 'react';
import moment from 'moment';
import ui from '../../../common/services/ui';
import utils from '../../../common/services/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDays } from '@fortawesome/free-regular-svg-icons';

export const types = {
	EDIT: 'edit',
	TRIAL: 'addTrial',
	COPY: 'copy',
	SINGLE: 'addSingle',
	AUTO_ENROL: 'autoEnrol'
};

export const actions = (enableSingleProgram) => {
	const actionsList = [
		{
			type: types.EDIT,
			resourceText: 'WeeklyProgram_Edit'
		},
		{
			type: types.COPY,
			resourceText: 'WeeklyProgram_Copy'
		}
		//{
		//	type: types.TRIAL,
		//	resourceText: 'WeeklyProgram_AddTrial',
		//	classes: 'text-danger'
		//},

	];

	if (enableSingleProgram) {
		actionsList.push({
			type: types.SINGLE,
			resourceText: 'WeeklyProgram_AddSingle'
		})
	}

	return actionsList;
}

export const getWeekday = (date) => {
	// The getDay() method returns the day of the week (from 0 to 6) for the specified date.
	// 0 is Sunday, 1 is Monday
	let mappedWeekday;
	if (date === 'string') {
		mappedWeekday = new Date(date).getDay();
	} else {
		mappedWeekday = date.getDay();
	}

	if (mappedWeekday == 0) {
		mappedWeekday = 7;
	}

	return mappedWeekday;
};

export const addMinutes = (date, minutes) => {
	return moment(date).add(minutes, 'm').toDate();
};

export const renderPanelHeader = (label, center, term) => {
	let text;
	if (term) {
		text = `${label} ( ${center && center.name} · ${term.name} )`;
	} else {
		text = `${label} ( ${center && center.name} )`;
	}
	const icon = <FontAwesomeIcon icon={faCalendarDays} key='icon' />;
	return [icon, text];
};

export const formatTime = (time) => {
	return ui.formatTime(utils.parseTime(time));
};

export const loadData = (props) => {
	const type = props.type;
	if (type == types.COPY) {
		const { fetchCenter, centerId } = props;
		if (centerId) {
			fetchCenter(centerId);
		}
	} else if (type == types.AUTO_ENROL) {
		const { fetchCenter, fetchTerm, centerId, termId } = props;
		if (centerId) {
			fetchCenter(centerId);
		}
		if (termId) {
			fetchTerm(termId);
		}
	} else if (type == types.EDIT || type == types.TRIAL || type == types.SINGLE) {
		const { loadGrades, loadUnpagedTeachers, loadUnpagedWeeklyProgram, fetchTerm, fetchCenter, centerId, termId } = props;
		if (centerId) {
			const onSuccessEvent = () => loadUnpagedTeachers({ franchiseeId: props.center.franchiseeId, enabled: 'true' });
			fetchCenter(centerId, onSuccessEvent);
		}
		if (termId) {
			fetchTerm(termId);
		}
		loadGrades();
		loadUnpagedWeeklyProgram({ centerId, termId, isDeleted: 'false' });
	}
};

export const filterPrograms = (weeklyPrograms, centerId, termId) => {
	const filteredPrograms = [];
	for (let key in weeklyPrograms) {
		const isMatching = weeklyPrograms[key].centerId == centerId && weeklyPrograms[key].termId == termId && !weeklyPrograms[key].isDeleted;
		if (isMatching) {
			filteredPrograms.push(weeklyPrograms[key]);
		}
	}
	return filteredPrograms;
};